module.exports = __webpack_public_path__ + "img/社会与责任.bb687bde.jpg";